/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  var MAX_WIDTH = 799;
  var $popup = $('#pdp-media-popup');
  var swiper = null;

  if (!$popup.length) return;

  // position:fixed would resolve against the gallery swiper's transform.
  if ($popup[0].parentElement !== document.body) document.body.appendChild($popup[0]);

  // Read on every open: filterImages() rebuilds the gallery on variant change.
  function galleryImages() {
    var images = [];

    $('.product-single__media-group .product-single__media-flex-wrapper').each(function () {
      var $slide = $(this);
      if ($slide.find('video, iframe, model-viewer').length) return;
      var $img = $slide.find('img').first();
      if ($img.length) images.push($img[0]);
    });

    return images;
  }

  function buildSlides(images) {
    var $wrapper = $popup.find('.swiper-wrapper').empty();

    $.each(images, function (i, img) {
      var $clone = $('<img>', {
        src: img.currentSrc || img.src,
        alt: img.alt || '',
      });

      var srcset = img.getAttribute('srcset');
      if (srcset) {
        $clone.attr('srcset', srcset);
        $clone.attr('sizes', '100vw');
      }

      $wrapper.append(
        $('<div class="swiper-slide pdp-media-popup__slide">').append(
          $('<div class="swiper-zoom-container">').append($clone)
        )
      );
    });
  }

  function openPopup(index) {
    var images = galleryImages();
    if (!images.length) return;

    buildSlides(images);

    $popup.removeClass('is-zoomed').addClass('is-open').attr('aria-hidden', 'false');
    $('html').addClass('pdp-media-popup-open');
    if (window.lockScroll) window.lockScroll();

    if (swiper) swiper.destroy(true, true);
    swiper = new Swiper($popup.find('.pdp-media-popup__swiper')[0], {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      initialSlide: index,
      zoom: { maxRatio: 4, minRatio: 1, toggle: true },
      pagination: {
        el: $popup.find('.pdp-media-popup__pagination')[0],
        clickable: true,
      },
      navigation: {
        prevEl: $popup.find('.pdp-media-popup__prev')[0],
        nextEl: $popup.find('.pdp-media-popup__next')[0],
      },
      on: {
        // Square crop only while at 1x — zoomed in shows the whole image.
        zoomChange: function (sw, scale) {
          $popup.toggleClass('is-zoomed', scale > 1);
        },
        slideChange: function () {
          if (this.zoom) this.zoom.out();
          $popup.removeClass('is-zoomed');
        },
      },
    });
  }

  function closePopup() {
    if (swiper && swiper.zoom) swiper.zoom.out();
    $popup.removeClass('is-open is-zoomed').attr('aria-hidden', 'true');
    $('html').removeClass('pdp-media-popup-open');
    if (window.unlockScroll) window.unlockScroll();
  }

  function canOpen() {
    return $(window).width() <= MAX_WIDTH && !$('.product-3d-window.open').length;
  }

  // Delegated from the slide wrapper, not document: Swiper stops click propagation
  // on its own element after a drag, and this handler sits below it.
  $('.product-single__media-group').on('click', '.product-single__media-flex-wrapper', function () {
    if (!canOpen()) return;

    var $slide = $(this);
    if ($slide.find('video, iframe, model-viewer').length) return;

    var index = $.inArray($slide.find('img').first()[0], galleryImages());
    if (index < 0) return;
    openPopup(index);
  });

  // Sticky thumb mirrors the variant image, which is the first gallery slide.
  $(document).on('click', '.product_thumb-sticky', function () {
    if (!canOpen()) return;
    openPopup(0);
  });

  $popup.find('.pdp-media-popup__close').on('click', function () {
    closePopup();
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $popup.hasClass('is-open')) closePopup();
  });
});
